import ContentBox from "../../../../components/ContentBox/ContentBox";
import BannerSection from "./components/Form/BannerSection";
import CounterSection from "./components/Form/CounterSection";
import SectionWrapper from "./components/SectionWrapper";
import SectionOne from "./components/Form/SectionOne";
import SectionTwo from "./components/Form/SectionTwo";
import SectionThree from "./components/Form/SectionThree";
import SectionFour from "./components/Form/SectionFour";
import SectionFive from "./components/Form/SectionFive";
import { useEffect } from "react";
import { details as detailsApi } from "./utils/slice";
import { HomePageSettingsBreadcrumb } from "../../../../config/BreadcrumbConfig";
import ToolBar from "../../../../components/ToolBar";
import { useAppDispatch, useAppSelector } from "../../../../utils/hooks/hooks";
import Options from "./components/Form/Options";
import CareerCompass from "./components/Form/CareerCompass";
import RegisterPermission from "./components/Form/RegisterPermission";

/**
 * Renders the LandingPage component containing the landing page settings form and details.
 *
 * @return {ReactElement} The rendered LandingPage component.
 */
const LandingPage: React.FC<any> = () => {
  const dispatch = useAppDispatch();
  const details = useAppSelector(state => state.landingPage.details);
  useEffect(() => {
    dispatch(detailsApi()).catch((error: any) => error);
  }, []);

  return (
    <>
      <ToolBar breadcrumbs={HomePageSettingsBreadcrumb}></ToolBar>
      <ContentBox>
        <SectionWrapper
          details={details?.banner}
          sectionName="Banner Section"
          sectionKey="banner"
          formItems={BannerSection}
        />
        {/* <SectionWrapper
          details={details?.counter}
          sectionName="Usp Section"
          sectionKey="counter"
          formItems={CounterSection}
        /> */}
        {/* <SectionWrapper
          details={details?.section_2}
          sectionName="About-Us Section"
          sectionKey="section_2"
          formItems={SectionTwo}
        /> */}
        {/* <SectionWrapper
          details={details?.section_1}
          sectionName="Process Section"
          sectionKey="section_1"
          formItems={SectionOne}
        /> */}
        {/* <SectionWrapper
          details={details?.section_3}
          sectionName="Archive Section"
          sectionKey="section_3"
          formItems={SectionThree}
        /> */}
        {/* <SectionWrapper
          details={details?.section_4}
          sectionName="Cta Section"
          sectionKey="section_4"
          formItems={SectionFour}
        /> */}
        {/* <SectionWrapper
          details={details?.section_5}
          sectionName="Training Solutions Section"
          sectionKey="section_5"
          formItems={SectionFive}
        /> */}
        {/* <SectionWrapper
          details={details?.options}
          sectionName="Video Section"
          sectionKey="options"
          formItems={Options}
        /> */}
        <SectionWrapper
          details={details?.career_compass}
          sectionName="Career Compass"
          sectionKey="career_compass"
          formItems={CareerCompass}
        />
        
      </ContentBox>
    </>
  );
};

export default LandingPage;
